import { render, staticRenderFns } from "./allotBusiness.vue?vue&type=template&id=6cc2052a&scoped=true&"
import script from "./allotBusiness.vue?vue&type=script&lang=js&"
export * from "./allotBusiness.vue?vue&type=script&lang=js&"
import style0 from "./allotBusiness.vue?vue&type=style&index=0&id=6cc2052a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc2052a",
  null
  
)

export default component.exports